import { makeStyles } from '@mui/styles';
import Lottie from 'react-lottie';
import animationData from '../lotties/serach';

const useStyles = makeStyles(() => ({
  innerDiv: {
    width: '30px',
    height: '30px',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center'
  }
}));
const SearchLoader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    },
  };
  
  const classes = useStyles();
  return (
    <div className={classes.innerDiv}>
      <Lottie options={defaultOptions} height={'100%'} width={'100%'} />
    </div>
  );
};

export default SearchLoader;
